import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';
import HtmlContentBox from 'presentation/components/shared/HtmlContentBox/HtmlContentBox';

interface Props {
  content: string;
}

const ServiceProductContentCard: FC<Props> = ({ content }) => {
  return (
    <AppCard p="25px" overflow="hidden">
      <HtmlContentBox content={content} />
    </AppCard>
  );
};

export default ServiceProductContentCard;
